<template>
  <div class="video">
    <video ref="video" loop v-if="widgetModel.settings.url" class="jw-video jw-reset" autoplay="autoplay" muted="muted" tabindex="-1" preload="auto" :src="this.widgetModel.settings.url"></video>
    <digital-ptz v-show="widgetModel.popupMode" :popup-mode="widgetModel.popupMode" class="video-ptz" :element="r"></digital-ptz>
  </div>
</template>

<script>
import WidgetMixin from "@/components/mixins/WidgetMixin";
import DigitalPtz from "@/components/DigitalPtz";

export default {
  name: "VideoWidget",
  components: {DigitalPtz},
  mixins: [WidgetMixin],
  widget: {
    title: "Live Video",
    actions: [
      {
        title: 'Set Video URL',
        icon: 'mdi mdi-file-video-outline',
        handler: function () {
          this.$buefy.dialog.prompt({
            message: `Enter video URL`,
            inputAttrs: {
              value: this.widgetModel.settings.url || ""
            },
            trapFocus: true,
            onConfirm: (value) => {
              this.updateWidget({
                settings: {
                  url: value
                }
              })
              // this.$set(this.widgetModel.settings, 'url', value)
              this.widgetModel.settings.url = value
            }
          })
        }
      }
    ]
  },
  data() {
    return {
      r: null
    }
  },
  mounted() {
    this.r = this.$refs.video
  }
}
</script>

<style scoped lang="scss">
  .video {
    position: relative;
    overflow: hidden;
  }
  .video-ptz {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 999;
  }
</style>
